// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// magaza.ecuador@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyABApNxUuNO6KpbtVffJaRHb5Y8guq4pjQ",
    authDomain: "hotel-mar-azul.firebaseapp.com",
    projectId: "hotel-mar-azul",
    storageBucket: "hotel-mar-azul.firebasestorage.app",
    messagingSenderId: "891761621635",
    appId: "1:891761621635:web:74706a4c7193ed3d45b9b6",
    measurementId: "G-KFBEGY3B3Y"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)